import { createContext } from "@lit/context";
import { FeatureFlag } from "@pentacode/core";

export type EnabledFeatures = Record<FeatureFlag, boolean>;

export const enabledFeatures = createContext<EnabledFeatures>(Symbol("enabledFeatures"));

export function parseFeaturesFromEnvVar(envString?: string): FeatureFlag[] {
    if (!envString) return [];

    return envString
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean) as FeatureFlag[];
}

export function loadEnabledFeatures(isBetaCustomer: boolean): EnabledFeatures {
    const features = parseFeaturesFromEnvVar(process.env.PTC_ENABLED_FEATURES);
    const betaFeatures = parseFeaturesFromEnvVar(process.env.PTC_BETA_FEATURES);

    const shouldShow = _shouldShowFeature(isBetaCustomer, features, betaFeatures);

    return Object.fromEntries(
        [...new Set<FeatureFlag>([...features, ...betaFeatures])].map((feat) => [feat, shouldShow(feat)])
    ) as EnabledFeatures;
}

function _shouldShowFeature(isBetaCustomer: boolean, features: FeatureFlag[], betaFeatures: FeatureFlag[]) {
    return function (feature: FeatureFlag) {
        return features.includes(feature) || (isBetaCustomer && betaFeatures.includes(feature));
    };
}
